import Vue from 'vue';

export default {
    state:{
      firebase_config:{
        tokenfcm:null
      }
    },
    mutations: {
      tokenfcm(state,tokenfcm){
        state.firebase_config.tokenfcm=tokenfcm;
      }
    },
    actions: { 
      Definir_TokenFCM({commit,state},tokenfcm){
        commit('tokenfcm',tokenfcm);
      }
    },
    getters: {  
      getFirebase_Config(state){
        return state.firebase_config;
      }
    },
    
}


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/modules/firebase_config.js